import React, { Component } from "react";

import { Row, Scroll, Wrapper } from "app/NativeComponents/common";
import SelectAllCheck from "./SelectAllCheck";
import ListColumn from "../ListColumn";
class HeaderRow extends Component {
  render() {
    return (
      <Row
        style={{
          justifyContent: "flex-start",
          alignItems: "flex-start",
          overflow: "hidden"
        }}
      >
        <SelectAllCheck {...this.props} />
        {this.props.list_settings &&
          this.props.list_settings.user_list_columns.map((column, i) => {
            if (column.main_column) {
              return (
                <ListColumn
                  key={i}
                  {...this.props}
                  column_section={column}
                  clearAll={this.props.clearAll}
                  pressProperty={this.props.pressProperty}
                  header_only={true}
                />
              );
            }
            return null;
          })}
        <Scroll
          className={"hide_scroll_bar"}
          scroll_ref={this.props._header_scroll_view}
          horizontal
          onScroll={e => {
            this.props.updateScrollPositions(
              this.props._header_scroll_view.current.scrollLeft
            );
          }}
        >
          <Row
            style={{
              justifyContent: "flex-start",
              alignItems: "flex-start"
            }}
          >
            {this.props.renderColumns(this.props, true)}
          </Row>
        </Scroll>
      </Row>
    );
  }
}

export default HeaderRow;
